import fetch from 'utils/fetch';

export function userOperateLogList(startTime,endTime,userName,moduleName,type, param, psize,currentPage) {
    const data = {
        startTime,
        endTime,
        userName,
        moduleName,
        type,
        param,
        psize,
        currentPage
    };
    return fetch({
        url: '/userOperateLogList',
        method: 'get',
        params : data
    });
}



// WEBPACK FOOTER //
// ./src/api/userOperateLog.js